import React from "react";
import styles from "./css/joinPartnerCore.module.css";
import { Container, Row, Col } from "react-bootstrap";

export default function JoinPantnerCore() {
  return (
    <div className={styles.joinContainer}>
      <h3 className={styles.joinHeader}>
        Join House Care Company to change your life
      </h3>
      <div className={styles.joinRow}>
        <div className={styles.joinCol}>
          <h3 className={styles.amountRupe}>₹1547 Cr</h3>
          <span className={styles.textSmall}>in revenue for</span>
          <span className={styles.textSmall}>Partners in 2024</span>
        </div>
        <div className={styles.joinCol}>
          <h3 className={styles.amountRupe}>40,000+</h3>
          <span className={styles.textSmall}>Partners on board</span>
        </div>

        <div className={styles.joinCol}>
          <h3 className={styles.amountRupe}>12,50,000+</h3>
          <span className={styles.textSmall}>Services fulfilled</span>
          <span className={styles.textSmall}>each month</span>
        </div>
      </div>
    </div>
  );
}
